export default {"src":"/_next/static/media/weight.6ceb9a95.svg","height":31,"width":30};